module.exports = __webpack_public_path__ + "887ae40901ed559bd2ea782642bae1ff.pdf";